import Layout from "@/src/layout/Layout";
import { client, urlFor } from "../../lib/client";
import { HeroSection, SecondSection, GallaryImages, FourthSection,GalleryVideos } from '../../src/components/portfolio'
import { Fragment } from "react";
import { NextSeo, ArticleJsonLd } from 'next-seo';

const ProjectDetails = ({  portfolioData, fetchHeader, fetchFooter, fHeaderMenuData}) => {

  const { pageBuilder, seo, slug } =  portfolioData;

  console.log(portfolioData)

  const renderPageBuilder = () => {
    return pageBuilder.map((section, index) => {
      const { _type } = section;
      switch (_type) {
        case "PSecondS":
          return <SecondSection key={index}  data={section} />;
        case "PGalleryS":
          return <GallaryImages key={index} data={section} />;
        case "PFourthS":
          return <FourthSection key={index} data={section} />;
          case "PGalleryVideoS": 
          return <GalleryVideos key={index} data={section} />;
        default:
          return null;
      }
    });
  };

  const heroSections = pageBuilder.filter((item) => item._type === "PHeroS");

  const { jsonLtd, metaDescription, metaTitle, seo_image, type } = seo;

  const heroSectionData = heroSections[0]




  return (
    <Fragment>
      <NextSeo
            title={metaTitle}
            description={metaDescription}
            canonical={`/portfolio/${slug.current}`}
            robots="index, follow"
            openGraph={{
              type: type,
              url: `/portfolio/${slug.current}`,
              title: metaTitle,
              description: metaDescription,
              image: urlFor(seo_image).url(),
            }} 
            additionalLinkTags={[
              {
                rel: 'icon',
                href: '/assets/images/favicon.png',
              },
              {
                rel: 'apple-touch-icon',
                href: 'https://www.test.ie/touch-icon-ipad.jpg',
                sizes: '76x76'
              },
             ]}
        />
        <ArticleJsonLd
     dataArray={JSON?.parse(jsonLtd)}
        />


    <Layout footerData={fetchFooter} headerData={fetchHeader} menuData={fHeaderMenuData} >
      {/* hero-first-section */}
      <HeroSection data={heroSectionData} />

      <section className="project-details-area pt-80 rel z-1">
        <div className="container container-1290">
          {/* second section paragraph and text, with special first letter */}

          {renderPageBuilder()}

          {/* <UploadForm /> */}
        </div>
      </section>
    </Layout>
    </Fragment>
  );
};

export const getServerSideProps = async (context) => {
  const pageSlug = context.query.slug;
  if (!pageSlug) {
    return {
      notFound: true,
    };
  }
      // fetching layouts
      const queryForFooter = `*[ _type == "Footer"  ][0]`;
      const fetchFooter = await client.fetch(queryForFooter);
      const queryForHeader = `*[ _type == "Header"  ][0]`;
      const fetchHeader = await client.fetch(queryForHeader);
      // fetching PortfolioPage
      const queryPortfolio = `*[ _type == "portfolioPage" && slug.current == "${pageSlug}"  ][0]`;
      const portfolioData = await client.fetch(queryPortfolio);

      // making the layout for pages



 // fetching header data
 const headMenuData = `*[ _type == "Header"  ]{
  menu_items[]->{
           title,
           slug,
           menu_name,
           menu_name_number,
 }
}[0]`;
const fHeaderMenuData =  await client.fetch(headMenuData);
const headerDataForMenu = fHeaderMenuData.menu_items;

  return {
    props: {
      portfolioData, fetchHeader, fetchFooter,fHeaderMenuData: headerDataForMenu,
    }
};
}

export default ProjectDetails;
